import React from 'react';
import { ArrowRight } from 'lucide-react';

const AppleGlyph = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M16.37 12.6c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.7-3.18-1.73-1.35-.14-2.64.8-3.33.8-.69 0-1.74-.78-2.87-.76-1.47.02-2.83.86-3.59 2.18-1.53 2.66-.39 6.59 1.1 8.75.73 1.05 1.6 2.24 2.73 2.2 1.1-.05 1.51-.71 2.84-.71 1.32 0 1.7.71 2.86.69 1.18-.02 1.93-1.07 2.65-2.13.84-1.22 1.18-2.4 1.2-2.46-.03-.01-2.3-.88-2.33-3.5zM14.2 6.13c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.68-.92 2.67.97.08 1.96-.49 2.56-1.22z" />
  </svg>
);

const PlayGlyph = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <path fill="#34A853" d="M3.6 2.3 13.4 12l-9.8 9.7c-.4-.2-.6-.6-.6-1.1V3.4c0-.5.2-.9.6-1.1z" />
    <path fill="#FBBC04" d="m16.8 15.4-3.4-3.4 3.4-3.4 3.9 2.2c1.1.6 1.1 1.8 0 2.4z" />
    <path fill="#EA4335" d="M16.8 15.4 13.4 12l-9.8 9.7c.4.2.9.2 1.4-.1z" />
    <path fill="#4285F4" d="M16.8 8.6 5 2.4c-.5-.3-1-.3-1.4-.1L13.4 12z" />
  </svg>
);

const StoreBadge = ({ glyph, store, testId }) => (
  <div className="lp-store" data-testid={testId} aria-label={`${store} — coming soon`}>
    {glyph}
    <span className="lp-store__text">
      <small>Coming soon to</small>
      <strong>{store}</strong>
    </span>
  </div>
);

export const StoreButtons = ({ prefix, showWebButton = true }) => (
  <div className="lp-ctas">
    {showWebButton && (
      <a href="#download" className="lp-btn lp-btn--primary" data-testid={`${prefix}-get-app-btn`}>
        Start 7-day free trial <ArrowRight size={18} />
      </a>
    )}
    <StoreBadge glyph={<AppleGlyph />} store="App Store" testId={`${prefix}-app-store-badge`} />
    <StoreBadge glyph={<PlayGlyph />} store="Google Play" testId={`${prefix}-google-play-badge`} />
  </div>
);
